import React, { useState } from 'react'
import FireSuppressionLayout from './FireSupressionLayout'
import ToggleUp from '../../../../Components/Icons/ToggleUp'
import ToggleDown from '../../../../Components/Icons/ToggleDown'
import { NuInput } from '../../../../Components/Utils/Input'
import { useFormik } from 'formik'
import * as yup from 'yup';

function FormView() {
     const [expandedIndex, setExpandedIndex] = useState(null);
     const [deliveryRows, setDeliveryRows] = useState([]);
    
      const handleToggle = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
      };
       const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
          clientDetails: { name: "", address: "" },
          inspectionDetails: { date: "", inspector: "" },
          serviceDetails: { serviceType: "", isUrgent: false },
          observation: { notes: "" }
        },
        validationSchema: yup.object({}),
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values) => {
          console.log("Submitting all data", values);
        }
      });
      const sections = [
        { title: "Client Details", key: "clientDetails" },
        { title: "Delivery Details", key: "inspectionDetails" },
      ];
      const handleInputChange = (e, rowIndex, key) => {
        const updatedRows = [...deliveryRows];
        updatedRows[rowIndex][key] = e.target.value;
        setDeliveryRows(updatedRows);
      };
      const handleAddRow = () => {
        setDeliveryRows([
          ...deliveryRows,
          {
            col1: "",
            col2: "",
            col3: "",
            col4: "",
            col5: "",
            col6: "",
            col7: "",
          },
        ]);
      };
      const handleDeleteRow = () => {
        setDeliveryRows((prev) => prev.slice(0, -1));
      };
  return (
    <FireSuppressionLayout
    BackButtonAccess={true}
    >
      <div className="w-full h-full  mt-0.5 ">
      <div className="sm:w-[98%] h-[calc(100vh-195px)]  ml-4  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between border-b-  z-10">
      
        
                     <div className="w-full bg-white   mt-1 ">
  {sections.map((section, index) => (
    <React.Fragment key={index}>
      <div className="w- py-4 flex gap-2 rounded-md bg-slate-200 px-3 border border-b-gray-300">
        <div
          className="cursor-pointer mt-1"
          onClick={() => handleToggle(index)}
        >
          {expandedIndex === index ? <ToggleUp /> : <ToggleDown />}
        </div>
        <p className=" text-xs font-medium text-[#111537]">
          {section.title}
        </p>
      </div>

      {expandedIndex === index && (
        <div className="bg-white p-4 border-t border-gray-200">
          <form>
            {section.key === "clientDetails" && (
              <>
                {/* <NuInput
                  name="clientDetails.name"
                  placeholder="Client "
                  value={formik.values.clientDetails.name}
                  onChange={formik.handleChange}
                  className="input-style"
                /> */}
                         <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
                         <NuInput
                              type="text"
                              label="Client"
                              placeholder="Client"
                              formik={formik}
                              name="clientDetails.name"
                              width="w-full md:w-1/3 md:-mt-2"
                            />
                            <NuInput
              type="text"
              label="Project"
              placeholder="Project"
              formik={formik}
              name="project"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="text"
              label="Contact Person"
              placeholder="Contact Person"
              formik={formik}
              name="contactPerson"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="number"
              label="Contact No."
              placeholder="Contact No."
              formik={formik}
              name="phone"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              width="w-full md:w-1/3 md:-mt-2"
            />
                {/* <NuInput
                  name="clientDetails.address"
                  placeholder="Address"
                  value={formik.values.clientDetails.address}
                  onChange={formik.handleChange}
                  className="input-style"
                /> */}
                </div>
              </>
            )}

            {section.key === "inspectionDetails" && (
 <div className="overflow-x-auto flex gap-4">
 <table className="w-full text-xs border border-gray-300 ">
   <thead className="bg-gray-100 h-10">
     <tr className=" w-full" >
       <th className="border px-2 py-1">S/N</th>
       <th className="border px-2 py-1">Date of Return</th>
       <th className="border px-2 py-1">Type of Extinguisher</th>
       <th className="border px-2 py-1">Capacity</th>
       <th className="border px-2 py-1">Unit</th>
       <th className="border px-2 py-1">Qty</th>
       <th className="border px-2 py-1">Client Signature</th>
      
     </tr>
   </thead>
 
   <tbody>
     {deliveryRows.map((row, rowIndex) => (
       <tr key={rowIndex}>
         {Object.keys(row).map((key, colIndex) => (
           <td key={colIndex} className="border px-2 py-1">
             <input
               type="text"
               className="w-full border-none outline-none bg-transparent"
               value={row[key]}
               onChange={(e) => handleInputChange(e, rowIndex, key)}
             />
           </td>
         ))}
       </tr>
     ))}
   </tbody>
 </table>
 <div className="">
 <button
   type="button"
   onClick={handleAddRow}
   className="bg-blue-500 text-white text-xs w-10 h-6 rounded hover:bg-blue-600"
 >
   + 
 </button>
 <button
type="button"
onClick={handleDeleteRow}
className="bg-red-500 text-white text-xs w-10 h-6 rounded hover:bg-red-600"
disabled={deliveryRows.length === 0}
>
− 
</button>
</div>
</div>
            )}

           

           
            <div className="text-right mt-4">
              <button
                type="button"
                onClick={() => alert("Saved section: " + section.title)}
                className="bg-blue-500 text-white px-4 py-1 rounded text-xs"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      )}
    </React.Fragment>
  ))}

  <div className="flex justify-end my-4">
    <button
      type="submit"
      onClick={formik.handleSubmit}
      className="bg-green-600 text-white px-6 py-2 rounded-lg text-xs"
    >
      Submit All
    </button>
  </div>
</div>
</div>
</div>
    </FireSuppressionLayout>
  )
}

export default FormView